import { ConfirmPopUp } from './ConfirmPopUp';
import { AdButton } from '../UI/elements/buttons/AdButton';
import { Button } from '../UI/elements/buttons/Button';
import { createSprite, translate } from '../utils/GameEngine';
import Sprite = PIXI.Sprite;

export class RetryConfirmPopup extends ConfirmPopUp {
    protected drawLayout(params: any): void {
        super.drawLayout(params);
    }

    protected drawButtons(): void {
        this.confirmButton = new AdButton(
            (): void => {
                this.params.callback();
            }
        );
        this.addChild(this.confirmButton);
        this.confirmButton.position.set(this.background.width / 2, this.buttonY);
    }
}